import { render, staticRenderFns } from "./PostPaidPayment.vue?vue&type=template&id=2bcaf1bf&scoped=true"
import script from "./PostPaidPayment.vue?vue&type=script&lang=js"
export * from "./PostPaidPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcaf1bf",
  null
  
)

export default component.exports